import PropTypes from 'prop-types';
import { useState } from 'react';
import { stringify as stringifyQuery } from 'hub-http/helpers/params';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { Link } from 'react-router-dom';
import { Spacer } from 'foundations-components/components/Spacer';
import { trackForgotPasswordClick } from 'LoginUI/lib/tracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PasswordInputForm = ({
  query,
  submitting,
  useDark,
  password,
  onChange
}) => {
  const [showPassword, setShowPassword] = useState(false);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(FormControl, {
      htmlFor: "password",
      label: /*#__PURE__*/_jsx(_Fragment, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "login.smartLogin.passwordPrimary"
        })
      }),
      help: /*#__PURE__*/_jsx(Button, {
        use: "link",
        onClick: () => setShowPassword(!showPassword),
        children: showPassword ? /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "login.form.hidePassword"
        }) : /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "login.form.showPassword"
        })
      }),
      children: /*#__PURE__*/_jsx(TextInput, {
        "data-test-id": "password-input-field",
        autoFocus: true,
        id: "current-password",
        type: showPassword ? 'text' : 'password',
        value: password,
        onChange: e => onChange(e.target.value),
        disabled: submitting,
        use: useDark ? 'on-dark' : 'default',
        autoComplete: 'off'
      })
    }), /*#__PURE__*/_jsx(Spacer, {
      space: "300"
    }), /*#__PURE__*/_jsx(Link, {
      to: {
        pathname: '/forgot',
        search: `?${stringifyQuery(query)}`
      },
      onClick: () => {
        trackForgotPasswordClick('control');
      },
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "login.form.forgotPassword"
      })
    }), /*#__PURE__*/_jsx(Spacer, {
      space: "300"
    })]
  });
};
PasswordInputForm.propTypes = {
  query: PropTypes.string,
  submitting: PropTypes.bool.isRequired,
  useDark: PropTypes.bool,
  password: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};
export default PasswordInputForm;